var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrec(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 101 26",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.63V26h3.357V3.315L0 6.63zM3.357 3.317h17.697V0H6.704L3.358 3.317zM19.376 10.195H6.714l-3.357 3.313h16.019v-3.313zM53.857 6.63v12.74l3.356 3.317V3.313L53.857 6.63zM74.91 26v-3.313H57.214L60.57 26h14.34z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.213 3.317h17.698V0H60.56l-3.348 3.317zM73.233 10.195H60.57l-3.357 3.313h16.02v-3.313zM47.143 26v-9.175l-3.357-3.317V26h3.357z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.786 10.195l-10.984.083-3.356 3.312V3.315l14.34-.002L40.43 0H26.09v26h3.356V13.591l14.34-.083h.004v-.004l3.353-3.312V6.63l-3.357-3.317v6.882zM101 26v-3.313H83.302L86.66 26H101zM101 0H86.65l-3.348 3.317H101V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.302 3.313L79.947 6.63v12.74l3.356 3.317V3.313z"
  })));
}
export default SvgFrec;